(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-consent"] && !Shopify.designMode) return;
  try {
    (() => {
    const banner = document.querySelector('[data-wf-cookie]')
    if (!banner) return

    const storageKey = banner.dataset.storageKey || 'wf-cookie-consent-v1'
    const acceptButton = banner.querySelector('[data-wf-cookie-accept]')
    const rejectButton = banner.querySelector('[data-wf-cookie-reject]')

    const buildConsent = (allowed) => ({
      analytics: allowed,
      marketing: allowed,
      preferences: allowed,
      sale_of_data: false
    })

    const syncShopifyConsent = (allowed) => {
      const consent = buildConsent(allowed)
      const applyConsent = () => {
        try {
          if (window.Shopify?.customerPrivacy?.setTrackingConsent) {
            window.Shopify.customerPrivacy.setTrackingConsent(consent, () => {})
          }
        } catch (error) {
          window.dispatchEvent(new CustomEvent('wf-cookie-consent-error', { detail: error }))
        }
      }

      try {
        if (window.Shopify?.loadFeatures) {
          window.Shopify.loadFeatures(
            [{ name: 'consent-tracking-api', version: '0.1' }],
            (error) => {
              if (error) {
                window.dispatchEvent(new CustomEvent('wf-cookie-consent-error', { detail: error }))
                return
              }
              applyConsent()
            }
          )
          return
        }
      } catch (error) {
        window.dispatchEvent(new CustomEvent('wf-cookie-consent-error', { detail: error }))
      }

      applyConsent()
    }

    const saveChoice = (choice) => {
      try {
        window.localStorage.setItem(
          storageKey,
          JSON.stringify({
            choice,
            savedAt: new Date().toISOString()
          })
        )
      } catch (error) {
        window.dispatchEvent(new CustomEvent('wf-cookie-consent-error', { detail: error }))
      }

      syncShopifyConsent(choice === 'accepted')
      banner.hidden = true
      document.body.classList.remove('wf-cookie-open')
      window.dispatchEvent(new CustomEvent('wf-cookie-consent', { detail: { choice } }))
    }

    try {
      if (!window.localStorage.getItem(storageKey)) {
        banner.hidden = false
        document.body.classList.add('wf-cookie-open')
      } else {
        const saved = JSON.parse(window.localStorage.getItem(storageKey) || '{}')
        if (saved?.choice === 'accepted' || saved?.choice === 'rejected') {
          syncShopifyConsent(saved.choice === 'accepted')
        }
      }
    } catch (error) {
      banner.hidden = false
      document.body.classList.add('wf-cookie-open')
      window.dispatchEvent(new CustomEvent('wf-cookie-consent-error', { detail: error }))
    }

    acceptButton?.addEventListener('click', () => saveChoice('accepted'))
    rejectButton?.addEventListener('click', () => saveChoice('rejected'))
  })()
  } catch(e) { console.error(e); }
})();

})();
